module.exports = __webpack_public_path__ + "img/part7.de25ba4e.png";